// import api from './api';

// class DashboardService {
//   // Get today's sales data
//   getTodaysSales = async () => {
//     try {
//       // Get today's date in YYYY.MM.DD format
//       const today = this.formatDate(new Date());
      
//       // Get inventoryId from active shift
//       const activeInventoryId = await this.getActiveInventoryId();
      
//       // Get salesPersonId from current user
//       const currentUser = JSON.parse(localStorage.getItem('user'));
//       const salesPersonId = currentUser?.id;
      
//       if (!activeInventoryId || !salesPersonId) {
//         throw new Error('Shift not started or user not found');
//       }
      
//       const params = {
//         inventoryId: activeInventoryId,
//         salesPersonId: salesPersonId,
//         fromDate: today,
//         toDate: today
//       };
      
//       const response = await api.get('/sales/cashh', { params });
//       return response.data;
//     } catch (error) {
//       throw this.handleError(error);
//     }
//   };
  
//   // Get sales data with custom date range
//   getSalesByDateRange = async (fromDate, toDate) => {
//     try {
//       const activeInventoryId = await this.getActiveInventoryId();
//       const currentUser = JSON.parse(localStorage.getItem('user'));
//       const salesPersonId = currentUser?.id;
      
//       if (!activeInventoryId || !salesPersonId) {
//         throw new Error('Shift not started or user not found');
//       }
      
//       const params = {
//         inventoryId: activeInventoryId,
//         salesPersonId: salesPersonId,
//         fromDate: this.formatDate(fromDate),
//         toDate: this.formatDate(toDate)
//       };
      
//       const response = await api.get('/sales/cashh', { params });
//       return response.data;
//     } catch (error) {
//       throw this.handleError(error);
//     }
//   };
  
//   // Get active inventory ID from shift
//   getActiveInventoryId = () => {
//     // Check if ShiftService is available
//     if (typeof ShiftService !== 'undefined' && ShiftService.getActiveInventoryId) {
//       return ShiftService.getActiveInventoryId();
//     }
    
//     // Fallback: get from localStorage
//     const shiftStr = localStorage.getItem('current_shift');
//     if (shiftStr) {
//       const shift = JSON.parse(shiftStr);
//       return shift.isActive ? shift.inventoryId : null;
//     }
    
//     return null;
//   };
  
//   // Format date to YYYY.MM.DD
//   formatDate = (date) => {
//     const year = date.getFullYear();
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const day = String(date.getDate()).padStart(2, '0');
//     return `${year}.${month}.${day}`;
//   };
  
//   // Parse date from YYYY.MM.DD format
//   parseDate = (dateStr) => {
//     const [year, month, day] = dateStr.split('.').map(Number);
//     return new Date(year, month - 1, day);
//   };
  
//   handleError = (error) => {
//     if (error.response) {
//       return new Error(error.response.data.message || 'An error occurred');
//     } else if (error.request) {
//       return new Error('No response from server. Please check your connection.');
//     } else {
//       return new Error('Request error: ' + error.message);
//     }
//   };
// }

// export default new DashboardService();
// import api from './api';

// class DashboardService {
//   // Get sales data for specific date
//   getSalesData = async (date) => {
//     try {
//       // Get current user
//       const user = JSON.parse(localStorage.getItem('user'));
//       if (!user) {
//         throw new Error('User not found');
//       }

//       // Get active inventory ID from shift
//       const shiftStr = localStorage.getItem('current_shift');
//       let inventoryId = null;
      
//       if (shiftStr) {
//         const shift = JSON.parse(shiftStr);
//         if (shift.isActive && shift.inventoryId) {
//           inventoryId = shift.inventoryId;
//         }
//       }

//       // If no active shift, return empty data
//       if (!inventoryId) {
//         return {
//           totals: {
//             CASH: { totalAmount: "0", count: 0 },
//             CHEQUE: { totalAmount: "0", count: 0 },
//             COLLECTION: { totalAmount: 0, count: 0 },
//             ALL: { totalAmount: "0", count: 0 }
//           }
//         };
//       }

//       // Format date to YYYY.MM.DD
//       const year = date.getFullYear();
//       const month = String(date.getMonth() + 1).padStart(2, '0');
//       const day = String(date.getDate()).padStart(2, '0');
//       const formattedDate = `${year}.${month}.${day}`;

//       // Prepare API parameters
//       const params = {
//         inventoryId: inventoryId,
//         salesPersonId: user.id,
//         fromDate: formattedDate,
//         toDate: formattedDate
//       };

//       // Make API call
//       const response = await api.get('/sales/cashh', { params });
      
//       if (response.data.success) {
//         return response.data;
//       }
      
//       throw new Error(response.data.message || 'Failed to fetch sales data');
      
//     } catch (error) {
//       console.error('Error fetching sales data:', error);
//       // Return empty data on error
//       return {
//         totals: {
//           CASH: { totalAmount: "0", count: 0 },
//           CHEQUE: { totalAmount: "0", count: 0 },
//           COLLECTION: { totalAmount: 0, count: 0 },
//           ALL: { totalAmount: "0", count: 0 }
//         }
//       };
//     }
//   };

//   // Format currency helper
//   formatCurrency = (amount) => {
//     if (!amount) return '0.00';
//     const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
//     return numAmount.toLocaleString('en-US', {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2
//     });
//   };
// }

// export default new DashboardService();



import api from './api';

class DashboardService {
  // Get sales data for specific date
//   getSalesData = async (date) => {
//     try {
//       // Get current user
//       const user = JSON.parse(localStorage.getItem('user'));
//       if (!user) {
//         throw new Error('User not found');
//       }

//       // Get active inventory ID from shift
//       const shiftStr = localStorage.getItem('current_shift');
//       let inventoryId = null;
      
//       if (shiftStr) {
//         const shift = JSON.parse(shiftStr);
//         if (shift.isActive && shift.inventoryId) {
//           inventoryId = shift.inventoryId;
//         }
//       }

//       // If no active shift, return empty data
//       if (!inventoryId) {
//         return {
//           totals: {
//             CASH: { totalAmount: "0", count: 0 },
//             CHEQUE: { totalAmount: "0", count: 0 },
//             COLLECTION: { totalAmount: 0, count: 0 },
//             ALL: { totalAmount: "0", count: 0 }
//           }
//         };
//       }

//       // Format date to YYYY.MM.DD
//       const year = date.getFullYear();
//       const month = String(date.getMonth() + 1).padStart(2, '0');
//       const day = String(date.getDate()).padStart(2, '0');
//       const formattedDate = `${year}.${month}.${day}`;

//       // Prepare API parameters
//       const params = {
//         inventoryId: inventoryId,
//         salesPersonId: user.id,
//         fromDate: formattedDate,
//         toDate: formattedDate
//       };

//       // Make API call
//       const response = await api.get('/sales/cashh', { params });
      
//       if (response.data.success) {
//         return response.data;
//       }
      
//       throw new Error(response.data.message || 'Failed to fetch sales data');
      
//     } catch (error) {
//       console.error('Error fetching sales data:', error);
//       // Return empty data on error
//       return {
//         totals: {
//           CASH: { totalAmount: "0", count: 0 },
//           CHEQUE: { totalAmount: "0", count: 0 },
//           COLLECTION: { totalAmount: 0, count: 0 },
//           ALL: { totalAmount: "0", count: 0 }
//         }
//       };
//     }
//   };
getCreditsData = async (userId, date = new Date()) => {
  try {
    // Format date to YYYY.MM.DD (same format as sales API)
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${year}.${month}.${day}`;
    
    const response = await api.get(`/credits`, {
      params: {
        userId: userId,
        limit: 10000, // Get all credits for the day
        startDate: formattedDate,
        endDate: formattedDate
      }
    });
    
    if (response.data.success) {
      return response.data;
    }
    
    throw new Error(response.data.message || 'Failed to fetch credits');
    
  } catch (error) {
    console.error('Error fetching credits:', error);
    return {
      summary: {
        totalAmount: 0,
        totalCredits: 0,
        averageAmount: 0,
        averageDays: 0
      }
    };
  }
};
getCreditsDataToday = async (userId, date = new Date()) => {
  try {
    // Format date to YYYY.MM.DD (same format as sales API)
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${year}.${month}.${day}`;
    
    const response = await api.get(`/credits`, {
      params: {
        userId: userId,
        limit: 10000, // Get all credits for the day
        endDate: formattedDate
      }
    });
    
    if (response.data.success) {
      return response.data;
    }
    
    throw new Error(response.data.message || 'Failed to fetch credits');
    
  } catch (error) {
    console.error('Error fetching credits:', error);
    return {
      summary: {
        totalAmount: 0,
        totalCredits: 0,
        averageAmount: 0,
        averageDays: 0
      }
    };
  }
};
getSalesData = async (date) => {
  try {
    // Get current user
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user) {
      throw new Error('User not found');
    }

    // Get active inventory ID from shift
    const shiftStr = localStorage.getItem('current_shift');
    let inventoryId = null;
    
    if (shiftStr) {
      const shift = JSON.parse(shiftStr);
      if (shift.isActive && shift.inventoryId) {
        inventoryId = shift.inventoryId;
      }
    }

    // If no active shift, return empty data
    if (!inventoryId) {
      return {
        totals: {
          CASH: { totalAmount: "0", count: 0 },
          CHEQUE: { totalAmount: "0", count: 0 },
          COLLECTION: { totalAmount: 0, count: 0 },
          ALL: { totalAmount: "0", count: 0 }
        },
        creditsSummary: {
          totalAmount: 0,
          totalCredits: 0
        }
      };
    }

    // Format date to YYYY.MM.DD
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${year}.${month}.${day}`;

    // Prepare API parameters for sales
    const params = {
      inventoryId: inventoryId,
      salesPersonId: user.id,
      fromDate: formattedDate,
      toDate: formattedDate
    };

    // Make sales API call
    const salesResponse = await api.get('/sales/cashh', { params });
    
    // Fetch credits data for the user WITH DATE FILTER
    const creditsData = await this.getCreditsData(user.id, date);
    
    let salesData = null;
    if (salesResponse.data.success) {
      salesData = salesResponse.data;
    }
    
    return {
      ...salesData,
      creditsSummary: creditsData.summary || {
        totalAmount: 0,
        totalCredits: 0
      }
    };
    
  } catch (error) {
    console.error('Error fetching sales data:', error);
    // Return empty data on error
    return {
      totals: {
        CASH: { totalAmount: "0", count: 0 },
        CHEQUE: { totalAmount: "0", count: 0 },
        COLLECTION: { totalAmount: 0, count: 0 },
        ALL: { totalAmount: "0", count: 0 }
      },
      creditsSummary: {
        totalAmount: 0,
        totalCredits: 0
      }
    };
  }
};

getSalesUpToToday = async () => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user) throw new Error('User not found');

    const shiftStr = localStorage.getItem('current_shift');
    let inventoryId = null;
    if (shiftStr) {
      const shift = JSON.parse(shiftStr);
      if (shift.isActive && shift.inventoryId) inventoryId = shift.inventoryId;
    }

    if (!inventoryId) {
      return {
        totals: { CASH: { totalAmount: "0", count: 0 }, CHEQUE: { totalAmount: "0", count: 0 }, COLLECTION: { totalAmount: 0, count: 0 }, ALL: { totalAmount: "0", count: 0 } },
        creditsSummary: { totalAmount: 0, totalCredits: 0 }
      };
    }

    const today = new Date();
    const formattedToday = `${today.getFullYear()}.${String(today.getMonth()+1).padStart(2,'0')}.${String(today.getDate()).padStart(2,'0')}`;

    const params = {
      inventoryId,
      salesPersonId: user.id,
      toDate: formattedToday, // up to today
      limit: 10000            // fetch all records
    };

    const salesResponse = await api.get('/sales/cashh', { params });
    const creditsData = await this.getCreditsDataToday(user.id, today);
  // all credits up to today

    return {
      ...salesResponse.data,
      creditsSummary: creditsData.summary || { totalAmount: 0, totalCredits: 0 }
    };

  } catch (error) {
    console.error('Error fetching sales up to today:', error);
    return {
      totals: { CASH: { totalAmount: "0", count: 0 }, CHEQUE: { totalAmount: "0", count: 0 }, COLLECTION: { totalAmount: 0, count: 0 }, ALL: { totalAmount: "0", count: 0 } },
      creditsSummary: { totalAmount: 0, totalCredits: 0 }
    };
  }
};
// DashboardService.js updates

getSalesDataMonthToDate = async () => {
  try {
    // Get current user
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user) {
      throw new Error('User not found');
    }

    // Get active inventory ID from shift
    const shiftStr = localStorage.getItem('current_shift');
    let inventoryId = null;
    
    if (shiftStr) {
      const shift = JSON.parse(shiftStr);
      if (shift.isActive && shift.inventoryId) {
        inventoryId = shift.inventoryId;
      }
    }

    // If no active shift, return empty data
    if (!inventoryId) {
      return {
        totals: {
          CASH: { totalAmount: "0", count: 0 },
          CHEQUE: { totalAmount: "0", count: 0 },
          COLLECTION: { totalAmount: 0, count: 0 },
          ALL: { totalAmount: "0", count: 0 }
        },
        creditsSummary: {
          totalAmount: 0,
          totalCredits: 0
        }
      };
    }

    // Calculate date range for month-to-date
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    
    // Format dates to YYYY.MM.DD
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}.${month}.${day}`;
    };

    const fromDate = formatDate(firstDayOfMonth);
    const toDate = formatDate(today);

    // Prepare API parameters for sales
    const params = {
      inventoryId: inventoryId,
      salesPersonId: user.id,
      fromDate: fromDate,
      toDate: toDate
    };

    // Make sales API call
    const salesResponse = await api.get('/sales/cashh', { params });
    
    // Fetch credits data for the date range
    const creditsResponse = await api.get('/credits', {
      params: {
        userId: user.id,
        startDate: fromDate,
        endDate: toDate,
        limit: 10000
      }
    });
    
    let salesData = null;
    if (salesResponse.data.success) {
      salesData = salesResponse.data;
    }
    
    let creditsData = {
      summary: {
        totalAmount: 0,
        totalCredits: 0
      }
    };
    
    if (creditsResponse.data.success) {
      creditsData = creditsResponse.data;
    }
    
    return {
      ...salesData,
      creditsSummary: creditsData.summary || {
        totalAmount: 0,
        totalCredits: 0
      }
    };
    
  } catch (error) {
    console.error('Error fetching month-to-date sales data:', error);
    // Return empty data on error
    return {
      totals: {
        CASH: { totalAmount: "0", count: 0 },
        CHEQUE: { totalAmount: "0", count: 0 },
        COLLECTION: { totalAmount: 0, count: 0 },
        ALL: { totalAmount: "0", count: 0 }
      },
      creditsSummary: {
        totalAmount: 0,
        totalCredits: 0
      }
    };
  }
}
  // Format currency helper
  formatCurrency = (amount) => {
    if (!amount) return '0.00';
    const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
    return numAmount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };
}

export default new DashboardService();
